export default __webpack_public_path__ + "static/media/ZIP_CH.4286706f.png";